import React, { useEffect } from 'react';
import StageCompletionStyles from '../styles/stageCompletion';
import { AuthPageStyles } from '../../authentication/styles';
import { Box, Button, Grid, Paper, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { ReactComponent as StageCompletion } from '../images/stageCompletion.svg';
import { routeMappings } from '../../constants';
import { STAGE_COMPLETION_MESSAGE_TIME } from '../../constants/timers';
import { useBasicDetails } from '../../store';
import { useHistory } from 'react-router-dom';
import { useQuery } from '../../common/hooks';
import { useTranslation } from 'react-i18next';

export const StageCompletionPage = (): JSX.Element => {
  const { t } = useTranslation();
  const history = useHistory();
  const query = useQuery();
  const theme = useTheme();
  const {
    template: { settings },
  } = useBasicDetails();
  const lgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const classes = AuthPageStyles(settings);
  const stageCompletionClasses = StageCompletionStyles(settings);
  const fromForm = query.get('fromForm');

  const redirectToTaskList = (): void => {
    history.push(`${routeMappings['BASICTASKLIST']}/:id`);
  };

  useEffect(() => {
    const redirectionTimeout = setTimeout(() => {
      redirectToTaskList();
    }, STAGE_COMPLETION_MESSAGE_TIME);

    return (): void => {
      clearTimeout(redirectionTimeout);
    };
  }, []);

  return (
    <Grid container justify="center" className={classes.container}>
      <Grid item xl={8} lg={10} className={classes.grid}>
        <Paper elevation={lgUp ? 1 : 0} className={classes.paper}>
          <Box textAlign="center">
            <Box className={stageCompletionClasses.stageCompletionHeading}>
              <StageCompletion width="120px" height="120px" />
              <Typography variant="h2">{t('wellDonePageHeading')}</Typography>
            </Box>
            <Box className={stageCompletionClasses.stageCompletionText}>
              <Box>
                <Typography variant="body1">
                  {fromForm ? t('wellDonePageMessage1') : t('wellDonePageMessage3')}
                </Typography>
              </Box>
              <Box>
                <Typography variant="body1">{t('wellDonePageMessage2')}</Typography>
              </Box>
            </Box>
          </Box>
          <Grid item xs={12}>
            <Box width="100%" textAlign="center">
              <Button
                type="submit"
                variant="outlined"
                color="primary"
                aria-disabled="false"
                onClick={redirectToTaskList}>
                <div>{t('next')}</div>
              </Button>
            </Box>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
};
